module.exports = __webpack_public_path__ + "assets/ic-nova.3bb05070.svg";